module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Texas Bix Bender\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Texas Bix Bender")]), _vm._v(" is the author of eighteen books, including the best-selling Don’t Squat With Yer Spurs On series. He has written for television and radio shows. He lives in Nashville, Tennessee.")], 1), _c('br'), _c('br')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Eb0HOU/tc-custom/9781423651697.jpg?1694766512208",
      "alt": "This image is the cover for the book Cowboy's Guide to Life"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cowboy's Guide to Life\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Saddle up with the author of the popular Don’t Squat with Your Spurs On series as he drops some knowledge as only a cowpoke can.")]), _c('br'), _c('br'), _vm._v("Texas Bix Bender’s witty and straightforward western wisdom is collected here for a new generation of cowboys. Gems include:“Always drink upstream from the herd.”“If you’re ridin’ a high horse, there ain’t no way to get down off it gracefully.”“Sorry looks back. Worry looks around. Faith looks up.”“If you ain’t pullin’ your weight, you’re pushin’ your luck.”“Never be too quick to criticize yourself. It’s not fair to all your friends and relatives who are dying to do it for you.”\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0